module.exports = __webpack_public_path__ + "img/time.a814a9ef.svg";